import { createFileRoute } from '@tanstack/react-router'
import ModuleTestDetail from '@/features/test/detail'

export const Route = createFileRoute('/_authenticated/test/$moduleId')({
  component: ModuleTestDetail,
})
